import React, { Suspense } from 'react';
import { Typography } from '@mui/material';
import { Streamingpackage } from '../../../../interfaces/StreamingProvider.interface';
import { getProviderData } from '../../../../services/util/streamingpackage/getProviderImageAndUrl';
import CustomTooltip from '../../../shared/tooltip/CustomTooltip';
import BCPriceTable from '../pricetable/BCPriceTable';
import CustomAccordion from '../../../shared/accordion/CustomAccordion';
import {
  StyledBox,
  StyledBox2,
  StyledBox3,
  StyledFlexWrapBox,
  StyledPaper,
} from './BCProvider.styled';
import { StreamingOffer } from '../../../../interfaces/StreamingOffer.interface';
import { Game } from '../../../../interfaces/Games.interface';
import { LiveOrHighlightOrBoth } from '../providerXcompetitonsXgames/types/HighlightOrLiveOrBoth.types';
import { ProviderXCompetitionsXgamesTableLazy } from '../providerXcompetitonsXgames/ProviderXcompetitionXgamesTable.lazy';

type BCProviderProps = {
  providers: Streamingpackage[];
  streamingOffers: StreamingOffer[];
  gamesFromSelectedTeams: Game[];
  competitions: string[];
  streamingPackages: Streamingpackage[];
  mode: LiveOrHighlightOrBoth;
  isPreview?: boolean;
};

const BCProvider: React.FC<BCProviderProps> = ({
  providers,
  streamingOffers,
  gamesFromSelectedTeams,
  competitions,
  streamingPackages,
  mode,
  isPreview = false,
}) => {
  const [expanded, setExpanded] = React.useState<boolean>(false); //priceDetails
  const toggleExpand = () => setExpanded(!expanded);
  const [expanded2, setExpanded2] = React.useState<boolean>(false); //Table
  const toggleExpand2 = () => setExpanded2(!expanded2);

  return (
    <StyledBox>
      {providers.length > 0 ? (
        <StyledPaper elevation={3}>
          <Typography variant="h5" gutterBottom fontStyle="bold">
            Best providers
          </Typography>
          <StyledFlexWrapBox>
            {providers.map((provider, index) => (
              <React.Fragment key={provider.id}>
                <StyledBox2>
                  <a
                    href={getProviderData(provider.name)?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <CustomTooltip
                      icon={
                        <img
                          src={getProviderData(provider.name)?.image}
                          style={{
                            borderRadius: '5px',
                            minWidth: '50px',
                            maxWidth: '50px',
                          }}
                          alt="Providerlogo"
                        />
                      }
                      title={provider.name}
                    />
                  </a>
                </StyledBox2>

                {index < providers.length - 1 && (
                  <StyledBox3>
                    <Typography variant="body1" color="text.secondary">
                      +
                    </Typography>
                  </StyledBox3>
                )}
              </React.Fragment>
            ))}
          </StyledFlexWrapBox>

          {!isPreview && (
            <>
              <CustomAccordion
                expanded={expanded}
                expandedContent={
                  <BCPriceTable
                    providers={providers}
                    isShowCheapeastActive
                    showSorted={false}
                    showWithIcons
                  />
                }
                mainText={'Price details'}
                toggleExpand={toggleExpand}
              />

              <CustomAccordion
                expanded={expanded2}
                isVerticalScrollable
                expandedContent={
                  <>
                    <Suspense fallback={<>Table is loading...</>}>
                      <ProviderXCompetitionsXgamesTableLazy
                        bestProviders={providers}
                        streamingOffers={streamingOffers}
                        gamesFromSelectedTeams={gamesFromSelectedTeams}
                        competitions={competitions}
                        streamingpackages={streamingPackages}
                        mode={mode}
                      />
                    </Suspense>{' '}
                  </>
                }
                mainText={'Table overview'}
                toggleExpand={toggleExpand2}
              />
            </>
          )}
        </StyledPaper>
      ) : (
        <Typography>No provider found for your selection</Typography>
      )}
    </StyledBox>
  );
};

export default BCProvider;
